<template>
    <div>
        <div class="equipment_info" v-if="equipment && equipment.id">
            #{{ equipment.id }} ({{ equipment.place.unit.short_name }} / {{ equipment.place.name }} / {{ equipment.name }})
        </div>
        <div class="version">
            v{{ version }}
        </div>
        
        <slot />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'LayoutTheme',

    computed: {
        ...mapGetters({
            equipment: 'getEquipment',
        }),

        version() {
            return process.env.VUE_APP_VERSION
        }
    }
}
</script>
